import { getColor } from 'common/constants/_colors';
import { BoxTitle } from 'components/ToggleBox';
import styled from 'styled-components';

export const StyledCategoryToolBoxTitle = styled.header`
  font-size: 1.5rem;
  display: flex;
  align-items: center;
  width: 100%;
  & > header {
  }
  & > aside {
    margin-left: auto;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    align-items: center;

    & > svg {
      width: 2rem;
      height: 2rem;
    }
  }
`;

export const StyledCategoryContent = styled.div`
  padding: 2rem;
`;

export const StyledCategoryItem = styled.div`
  & ${BoxTitle} {
    background: ${getColor('zircon')};
  }
  margin-bottom: 1rem;
`;

export const StyledCategoriesList = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0;
`;
